import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-three-lesson-two-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitThreeLessonTwoGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 3, Lesson 2 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 2: SCANS Workplace Skills and Competencies";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
